<span
  class="project-color-box"
  [ngStyle]="{ 'background-color': color }"
></span>
